import { useEffect, useState } from "react";
import styles from "../index.module.scss";
import DeleteIcon from "./DeleteIcon.svg";
import DownArrow from "./DownArrow.svg";
import AddIcon from "./AddIcon.svg";
export default function QuestionConfig({
  setTotalMarks,
  setQuestions,
  questions,
  close,
  question,
  setQuestion,
  initialOptions,
}) {
  const [ansDrpDwn, setAnsDrpDwn] = useState(false);

  const clearQuestion = () => {
    setQuestion((prev) => ({
      ...prev,
      questionText: "",
      answerList: initialOptions,
      answer: "",
      answerId: "",
      marks: 0,
    }));
  };

  const indexMap = {
    1: "A",
    2: "B",
    3: "C",
    4: "D",
    5: "E",
    6: "F",
  };

  const hasValidOption = question.answerList.some(
    (opt) => opt.option_text.trim() !== ""
  );
  const isDisabled =
    !question.questionText.trim() ||
    !question.marks ||
    !hasValidOption ||
    question.answer === "";

  useEffect(() => {
    if (!question.answerId) return;

    const selected = question.answerList.find(
      (opt) => opt.option_id === question.answerId
    );

    if (selected && selected.option_text !== question.answer) {
      setQuestion((prev) => ({
        ...prev,
        answer: selected.option_text,
      }));
    }
  }, [question.answerList, question.answerId]);

  return (
    <section className={styles.quesConfig}>
      <div className={styles.quesConfigTitle}>
        {`${
          questions.some(
            (q) => q.questionId.toString() === question.questionId.toString()
          )
            ? "Edit"
            : "Create"
        } Question`}
      </div>
      <section className={styles.quesConfigContainer}>
        <div className={styles.quesConfigContainerTitle}>Question</div>
        <textarea
          className={styles.quesConfigContainerInput}
          value={question.questionText}
          onChange={(e) => {
            if (e.target.value.toString().length > 100) return;
            setQuestion((prev) => ({ ...prev, questionText: e.target.value }));
          }}
          placeholder="Enter your question here"
        />
      </section>
      <div className={styles.questionConfigOptionHead}>
        <div className={styles.questionConfOptionHead}>Options</div>
        {question.answerList.length < 6 && (
          <button
            onClick={() => {
              if (question.answerList.length < 6) {
                setQuestion((prev) => ({
                  ...prev,
                  answerList: [
                    ...prev.answerList,
                    {
                      option_id: `temp-0${prev.answerList.length}`,
                      option_text: "",
                    },
                  ],
                }));
              }
            }}
            className={styles.questionConfOptionBtn}
          >
            <img src={AddIcon} alt="Add" />
            <div>Add Option</div>
          </button>
        )}
      </div>
      <div className={styles.questionConfigOptionsGrid}>
        {question.answerList.map((i, index) => (
          <div key={index} className={styles.questionConfigOption}>
            <div className={styles.questionConfigOptionIndex}>{`${
              indexMap[index + 1]
            })`}</div>
            <input
              className={styles.questionConfigOptionText}
              value={i.option_text}
              placeholder={`Option ${indexMap[index + 1]}`}
              onChange={(e) => {
                const newText = e.target.value;
                if (newText.toString().length > 45) return;

                setQuestion((prev) => {
                  const updatedOptions = prev.answerList.map((opt, iIdx) =>
                    iIdx === index ? { ...opt, option_text: newText } : opt
                  );

                  const editedOption = prev.answerList[index];
                  const isAnswerBeingEdited =
                    editedOption.option_id === prev.answerId;

                  return {
                    ...prev,
                    answerList: updatedOptions,
                    ...(isAnswerBeingEdited && {
                      answer: "",
                      answerId: "",
                    }),
                  };
                });
              }}
            />

            {question.answerList.length > 2 && (
              <img
                onClick={() =>
                  setQuestion((prev) => ({
                    ...prev,
                    answerList: prev.answerList.filter(
                      (_, idx) => idx !== index
                    ),
                  }))
                }
                src={DeleteIcon}
                alt="Delete"
                style={{ cursor: "pointer" }}
              />
            )}
          </div>
        ))}
      </div>
      <div className={styles.questionRule}></div>
      <div className={styles.quesInfoFlex}>
        <div className={styles.quesInfoAnsBox}>
          <div className={styles.quesInfoAnsHead}>Correct Answer</div>
          <div
            onClick={() => {
              const filledOptions = question.answerList.filter(
                (opt) => opt.option_text.trim() !== ""
              );
              if (
                question.answerList.length > 2 ||
                (question.answerList.length === 2 && filledOptions.length === 2)
              ) {
                setAnsDrpDwn((prev) => !prev);
              }
            }}
            className={styles.quesConfigAnswerInput}
          >
            {/* <div></div> */}
            <input
              value={
                question.answer
                  ? question.answer.length > 20
                    ? `${question.answer.substring(0, 19)}...`
                    : question.answer
                  : ""
              }
              placeholder="Select Answer"
              readOnly
            />

            {(question.answerList.length > 2 ||
              (question.answerList.length === 2 &&
                question.answerList.every(
                  (opt) => opt.option_text.trim() !== ""
                ))) && <img src={DownArrow} alt="Down" />}
            {ansDrpDwn && (
              <div className={styles.quesInfoAnsDrpDwn}>
                {question.answerList.map((opt, idx) =>
                  opt.option_text.trim() !== "" ? (
                    <div
                      key={idx}
                      className={styles.dropdownItem}
                      onClick={() =>
                        setQuestion((prev) => ({
                          ...prev,
                          answerId: opt.option_id,
                          answer: `${opt.option_text}`,
                        }))
                      }
                    >
                      {`${indexMap[idx + 1]}) ${opt.option_text}`}
                    </div>
                  ) : null
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.quesInfoAnsBox}>
          <div className={styles.quesInfoAnsHead}>{`Weightage (Marks)`}</div>
          <div className={styles.quesConfigAnswerInput}>
            0
            <input
              type="text"
              min="1"
              max="9"
              value={`${question.marks}`}
              className={styles.marksInput}
              onChange={(e) => {
                const val = e.target.value;

                if (/^\d?$/.test(val)) {
                  setQuestion((prev) => ({
                    ...prev,
                    marks: val === "" ? "" : parseInt(val, 10),
                  }));
                }
              }}
            />
          </div>
        </div>
      </div>
      <div className={styles.questionActionBtns}>
        <div onClick={clearQuestion} className={styles.questionClearBtn}>
          Clear
        </div>
        <div
          onClick={() => {
            if (isDisabled) return;

            setQuestions((prev) => {
              const existingIndex = prev.findIndex(
                (q) =>
                  q.questionId.toString() === question.questionId.toString()
              );

              if (existingIndex !== -1) {
                // If question already exists (even temp), update it
                const updated = [...prev];
                const prevMarks = updated[existingIndex].marks;
                updated[existingIndex] = question;

                setTotalMarks((m) => m - prevMarks + question.marks);
                return updated;
              } else {
                // New question, add it
                setTotalMarks((m) => m + question.marks);
                return [...prev, question];
              }
            });

            close();
          }}
          className={`${styles.questionAddBtn} ${
            isDisabled ? styles.disabledQuestionBtn : ""
          }`}
        >
          {`${
            questions.some(
              (q) => q.questionId.toString() === question.questionId.toString()
            )
              ? "Edit"
              : "Create"
          } Question`}
        </div>
      </div>
    </section>
  );
}
